import WhetherSolve from '@/sub-luca-plugin/components/qa-render/whether-solve';
import TeacherQaTips from './teacher-qa-tips';
import { ISolveStatus } from '@/sub-luca-plugin/types/models/qa';
import './index.scss';

export interface ITeacherQaTipsCard {
    type: 'teacherQaTips';
    date: string;
}

// interface IWaitTeacherReply {
//     type: 'waitTeacherReply';
// }

interface IWhetherSolve {
    type: 'whetherSolve';
    title?: string;
    /**
     * 0 待解决 1 已解决 2 未解决
     */
    state: ISolveStatus;
}

export type ISystem = {
    role: 'system';
} & (ITeacherQaTipsCard | IWhetherSolve);

const System = (data: ISystem) => {
    switch (data.type) {
        case 'whetherSolve':
            return <WhetherSolve state={data.state} title={data.title} />;
        case 'teacherQaTips':
            return <TeacherQaTips date={data.date} />;
        default:
            return null;
    }
};

export default System;
